module.exports = __webpack_public_path__ + "img/banner222.26555f11.png";